import { ICONS } from "@/constants"
import React from "react"
import CommonIcon from "@/components/common/Icon/Icon"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { FacebookShareButton } from "react-share"
import useGetFullUrl from "@/hooks/useGetFullUrl"

const Icon = styled(CommonIcon)`
	cursor: pointer;
	--size: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	width: var(--size);
	height: var(--size);

	svg {
		transition: transform var(--rgr-duration) var(--ease);

		path,
		circle {
			transition: fill var(--rgr-duration) var(--ease);
		}
	}

	&:hover {
		svg {
			transform: scale(1.113);
		}

		--cl: ${({ theme }) => theme.colors.chilliRed};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		--size: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) and (orientation: landscape) {
		--size: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
	}

	&.big {
		--size: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};

		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
			--size: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
		}

		@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) and (orientation: landscape) {
			--size: ${getCssSizeValue(50, BREAKPOINTS.DESKTOP)};
		}
	}
`

export default function ShareButton({ iconName = ICONS.FACEBOOK, iconColor = "richBlue", Provider = FacebookShareButton, big = false }) {
	const url = useGetFullUrl()

	return (
		<Provider url={url}>
			<Icon name={iconName} color={iconColor} className={big ? "big" : ""} />
		</Provider>
	)
}
